import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { StyledBtnBack } from './styles/StyledBtnBack';

class BtnBack extends Component {
  render() {
    const { linkTo, text } = this.props;

    return (
      <StyledBtnBack>
        <Link className="btn-back-content disable-select"
          to={linkTo}
        >
          <span className="btn-back-arrow">
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </span>
          <span className="btn-back-text">
            { text }
          </span>
        </Link>
      </StyledBtnBack>
    );
  }
}


BtnBack.propTypes = {
  linkTo: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};


export default BtnBack;



// WEBPACK FOOTER //
// ./src/common/BtnBack/BtnBack.js